import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@base-ui/react/tabs";
import { forwardRef, isValidElement } from "react";
import { cn } from "../../utils/index.js";
import { CdnIcon, validGoogleSymbols } from "../CdnIcon/index.js";
import { Span } from "../Text/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { tabsVariants } from "./Tabs.variants.js";
const PanelTabsHeader_TabListItem = /*#__PURE__*/ forwardRef(function({ disabled, iconLeft, iconRight, iconSize, iconClass, label, helperText, value, labelProps, helperTextProps, tabClass, emphasis = 'regular', stacked = false, tabLabelContentClass, onClick }, ref) {
    const { tabLabelContent, tab, icon } = tabsVariants({
        emphasis,
        stacked
    });
    const tabClasses = cn(tab(), tabClass);
    const iconClasses = cn(icon(), iconClass);
    const tabLabelContentClasses = cn(tabLabelContent(), tabLabelContentClass);
    const renderIcon = (side)=>{
        if ('left' === side && null == iconLeft) return;
        if ('right' === side && null == iconRight) return;
        const icon = 'left' === side ? iconLeft : iconRight;
        if ('string' == typeof icon && validGoogleSymbols.includes(icon)) return /*#__PURE__*/ jsx(CdnIcon, {
            iconName: icon,
            size: iconSize,
            className: iconClasses
        });
        if ('function' == typeof icon) return icon({
            className: iconClasses
        });
        if (/*#__PURE__*/ isValidElement(icon) && 'string' != typeof icon && 'number' != typeof icon) return icon;
    };
    return /*#__PURE__*/ jsxs(Tabs.Tab, {
        ref: ref,
        className: tabClasses,
        value: value,
        disabled: disabled,
        onClick: onClick,
        children: [
            renderIcon('left'),
            /*#__PURE__*/ jsxs("div", {
                className: tabLabelContentClasses,
                children: [
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body2",
                        ...labelProps,
                        children: label
                    }),
                    /*#__PURE__*/ jsx(Span, {
                        textStyle: "body3",
                        ...helperTextProps,
                        children: helperText
                    })
                ]
            }),
            renderIcon('right')
        ]
    });
});
function PanelTabsHeader({ tabsContent, tabClass, iconClass, emphasis, stacked = false, tabLabelContentClass }) {
    return tabsContent.map((tabContent)=>{
        const { disabled, iconLeft, iconRight, iconSize = '20', label, helperText, value, labelProps, helperTextProps, tooltipProps, onClick } = tabContent;
        const TabItemProps = {
            disabled,
            iconLeft,
            iconRight,
            iconClass,
            iconSize,
            label,
            helperText,
            value,
            labelProps,
            helperTextProps,
            tabClass,
            emphasis,
            stacked,
            tabLabelContentClass,
            onClick
        };
        if (tooltipProps) return /*#__PURE__*/ jsx(Tooltip, {
            emphasis: "bold",
            slots: {
                triggerSlot: 'data-disabled:cursor-not-allowed cursor-pointer'
            },
            triggerNode: /*#__PURE__*/ jsx(PanelTabsHeader_TabListItem, {
                ...TabItemProps
            }),
            isNativeTriggerNodeButton: true,
            ...tooltipProps
        }, value);
        return /*#__PURE__*/ jsx(PanelTabsHeader_TabListItem, {
            ...TabItemProps
        }, value);
    });
}
export { PanelTabsHeader, PanelTabsHeader_TabListItem as TabListItem };
